import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsHandcycleNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M7.447 7.658l-1.789.895 2.686 5.37a14.366 14.366 0 01-1.352-.191 3.5 3.5 0 10-.713 1.895C7.283 15.844 8.52 16 10 16h1v-.008c.08.006.158.009.237.009H15a1 1 0 00.707-.293l1.39-1.39A3.501 3.501 0 0024 13.5a3.5 3.5 0 00-5.99-2.46l-3.272-1.746a1.75 1.75 0 10-.941 1.764l2.433 1.298L14.586 14h-3.35a1 1 0 01-.894-.553zM2 13.5a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zM20.5 12a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
        fill=""
      />
    </svg>
  )
);
SvgSportsHandcycleNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsHandcycleNormalSmall;
